// extracted by mini-css-extract-plugin
export var box = "_4n-2";
export var checkboxControl = "_4n-0";
export var checkboxRow = "_4n-9";
export var checked = "_4n-3";
export var descriptionSpacer = "_4n-b";
export var disabled = "_4n-4";
export var icon = "_4n-7";
export var input = "_4n-1";
export var labelSpacer = "_4n-a";
export var medium = "_4n-6";
export var small = "_4n-5";
export var text = "_4n-8";